import { useState } from 'react';
import Layout from '@/components/layout/Layout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { BulkDamageEntryTable } from '@/components/inventory/BulkDamageEntryTable';
import { DamagesTable } from '@/components/inventory/DamagesTable';
import { ClipboardList, History } from 'lucide-react';

export default function InventoryDamages() {
  const [activeTab, setActiveTab] = useState('record');

  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Damage Tracking</h1>
          <p className="text-muted-foreground">
            Record and track product damages, spoilage, and losses
          </p>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
          <TabsList>
            <TabsTrigger value="record" className="gap-2">
              <ClipboardList className="h-4 w-4" />
              Record Damages
            </TabsTrigger>
            <TabsTrigger value="history" className="gap-2">
              <History className="h-4 w-4" />
              History
            </TabsTrigger>
          </TabsList>

          <TabsContent value="record">
            <Card>
              <CardHeader>
                <CardTitle>Record Daily Damages</CardTitle>
                <CardDescription>
                  Enter quantities for damaged products. Only rows with quantities will be saved.
                </CardDescription>
              </CardHeader>
              <CardContent>
                <BulkDamageEntryTable onSaveSuccess={() => setActiveTab('history')} />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="history">
            <Card>
              <CardHeader>
                <CardTitle>Damage History</CardTitle>
                <CardDescription>
                  View all recorded product damages and losses
                </CardDescription>
              </CardHeader>
              <CardContent>
                <DamagesTable />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
